import React from 'react'
import { ButtonsComp, TypeFaceText } from '../../../inputs/buttons.component'
import {
  RadioGroupButtons,
  ErrorTextComp,
} from '../../../inputs/fields.component'
import HelpTextComp from '../../../helper/helptext.component'
import SearchBoxComp from '../../../inputs/searchbox.component'
import {
  isNumberWithComma,
  uniqueArrayObject,
} from '../../../../utils/function'
import * as MetricFunc from '../../../../utils/metric'
import { RollUpTableComp, PeopleSearchBoxList } from './rolluptable.component'
import TeamServices from '../../../../services/team.services'
import GoalServices from '../../../../services/goal.services'
import PermissionComp from './permission.component'
import { reactLoader, removeReactLoader, constructNestedKRPayload } from '../../../../utils/common.js'
import DeleteCommonModal from '../../../deleteCommonModal.component'
import KrAlignDependance from './krAlignDependence'
import NestedInlineComp from './NestedInline.component'
import AddKrTag from '../../../../krTags/components/addkrTag.component'
import { Textfield, Checkbox, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
import Customokr from "../../../custom_fields/customobj/Customokr";
import KrRelationshipWrapper from './krRelationshipWrapper'
import KrMilestonesSection from './KrMilestonesSection';
import { krdetailConstants } from '../../../../constants/krdetails.constants';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
import { isKrDurationChangedFromSaved } from '../../../../utils/krQuarterDuration';
import { KR_CAUTION, resolveKrCaution } from '../../../../utils/krCautionPrecedence';

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
		padding: 0;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;
const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  max-width: fit-content;
  height: 38px !important;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  #unit-measure-dropdown{
    min-width: 177px;
  }
  #cal-overall-dropdown{
    min-width: 226px;
  }
  #select-day-dropdown{
    min-width: 120px;
  }
}
`;

class GroupResultsComp extends React.Component {
  constructor(props) {
    super(props)
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    let metricObj = {
      target: '',
      stretch: '',
      measure_metric_data: 1,
      progress_type: 2,
      metric: 1,
      progress_consider: false,
      interval: 2,
      weekly_update_day: 5,
      metricSurvey: [],
      counting: 5,
      lower_limit: '',
      upper_limit: '',
      selectInterval: 0,
    }
    let activeTab = ''
    let isStretchEnabled = this.props.addOkrData.isStretchEnabled ?? this.props.goalDetails.isStretchEnabled ?? false
    let committedKRFlag = isStretchEnabled && metricObj.committed_target !== null ? parseInt(this.props.item.committed_target) : 0
    if (Object.keys(this.props.item).length) {
      let { source, type } = this.props.item
      if (source == 5 && type == 1) {
        metricObj = Object.assign({}, metricObj, this.props.item)
        metricObj.progress_consider =
          metricObj.progress_consider == '0' ? true : false
        metricObj.counting =
          metricObj.counting == '5' || metricObj.counting == '6'
            ? metricObj.counting
            : 7
        activeTab =
          metricObj.counting == '5'
            ? 'group-yesorno'
            : metricObj.counting == '6'
            ? 'group-scale'
            : 'group-numeric'
        metricObj.measure_metric_data =
          metricObj.measure_metric_data == '0'
            ? 1
            : metricObj.measure_metric_data
        metricObj.progress_type =
          activeTab != 'group-numeric' ? 2 : metricObj.progress_type
        if (isStretchEnabled) {
          metricObj.stretch = metricObj.stretch_target ? metricObj.stretch_target :  metricObj.target && !committedKRFlag ? metricObj.target :''
          metricObj.target =  (!committedKRFlag && metricObj.target == '') ||
                              (committedKRFlag)
                              ? this.props.item.target : ''
          metricObj.committed_target = committedKRFlag
        }
      }
    }
    this.state = {
      activeTab,
      metricObj,
      errors: {},
      checkedValues: [],
      hide: false,
      teamPermissionSelected:
        this.props.item && this.props.item.permission_teams
          ? this.props.item.permission_teams
          : this.props.goalDetails.type == 1 &&
            this.props.goalDetails.default_permission_teams &&
            Object.keys(this.props.goalDetails.default_permission_teams)
              .length > 0
          ? this.props.goalDetails.default_permission_teams
          : [],
      bizPermissionSelected:
        this.props.item && this.props.item.permission_biz
          ? this.props.item.permission_biz
          : [],
      permissionstate:
        this.props.item && this.props.item.permission
          ? this.props.item.permission.split(',').map(Number)
          : this.props.goalDetails.type == 1
          ? this.props.goalDetails.default_permission &&
            Object.keys(this.props.goalDetails.default_permission).length > 0
            ? this.props.goalDetails.default_permission.split(',').map(Number)
            : [8]
          : [10],
      permissionHelpPopUp: false,
      confirmPopup: false,
      krAlingSelected:
        this.props.item &&
        this.props.item.kr_aligns !== undefined &&
        this.props.item.kr_aligns.length > 0
          ? this.props.item.kr_aligns
          : [],
      krDependenciesSelected:
        this.props.item &&
        this.props.item.kr_dependent !== undefined &&
        this.props.item.kr_dependent.length > 0
          ? this.props.item.kr_dependent
          : [],
      intervalConfirmPopup: false,
      tags: [],
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      customFiledRequired:false,
      isCustomSave:[],
      isRequirdCustomOkr:[],
      customInputData:[],
      isStretchEnabled: isStretchEnabled,
      isAnuualQChange:false,
      cadenceChanged: false,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
      milestones: this.props.item?.milestones ?? [],
    }

    this.clickButtonEvent = this.clickButtonEvent.bind(this)
    this.saveGroupResults = this.saveGroupResults.bind(this)
    this.changeInterval = this.changeInterval.bind(this)
    this.changeExcludeObjective = this.changeExcludeObjective.bind(this)
    this.renderPeopleTeamsSearchResults =
      this.renderPeopleTeamsSearchResults.bind(this)
    this.changeYesOrNoOption = this.changeYesOrNoOption.bind(this)
    this.checkPeopleValue = this.checkPeopleValue.bind(this)
    this.changeWeekDayUpdate = this.changeWeekDayUpdate.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.changeCounting = this.changeCounting.bind(this)
    this.changeMetricTypeOption = this.changeMetricTypeOption.bind(this)
    this.changeInputValue = this.changeInputValue.bind(this)
    this.changeProgressType = this.changeProgressType.bind(this)

    this.permissionData = this.permissionData.bind(this)
    this.teamPermissionData = this.teamPermissionData.bind(this)

    this.teamUserCollections = {}
    this.TeamServices = new TeamServices()
    this.GoalServices = new GoalServices()
    this.krMilestonesSectionRef = React.createRef()
    this.exitDeleteModal = this.exitDeleteModal.bind(this)
    this.saveItems = this.saveItems.bind(this)
    this.saveAlignArr = this.saveAlignArr.bind(this)
    this.saveDependentArr = this.saveDependentArr.bind(this)
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.isSaveCustom =this.isSaveCustom.bind(this)
    this.renderError = this.renderError.bind(this);
    this.saveGroupResultsCompleted = this.saveGroupResultsCompleted.bind(this);
    this.getMilestonesPayload = this.getMilestonesPayload.bind(this);
    this.handleMilestonesChange = this.handleMilestonesChange.bind(this);
  }

  getMetricTypeTextOptions() {
    return MetricFunc.getMetricTypeOptions().map((m) => ({
      ...m,
      name: 'Counting as ' + m.name.toLowerCase(),
    }))
  }

  clickButtonEvent(item) {
    let metricObj = this.state.metricObj
    let selectInterval = metricObj.selectInterval
    let stateVal = { activeTab: item.id, errors: {} }
    if (metricObj.interval == 5 && item.id == 'group-numeric') {
      metricObj.interval = 2
      stateVal = Object.assign({}, stateVal, { metricObj: metricObj })
    } else if (
      item.id != 'group-numeric' &&
      selectInterval == 0 &&
      typeof this.state.metricObj.id === 'undefined'
    ) {
      metricObj.interval = 5
      stateVal = Object.assign({}, stateVal, { metricObj: metricObj })
    }
    //console.log(stateVal);
    this.setState(stateVal)
  }
  componentDidMount() {
    this.props.setSavedAnnualDuration(this.props.item.isQuarter,this.props.item.quarter_name,this.props.item.id)
  }
  permissionData(perData) {
    this.setState({
      permissionstate: perData,
    })
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData,
    })
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData,
    })
  }

  getMilestonesPayload() {
    // Ensure milestones is an array before attempting to use array methods
    if (!Array.isArray(this.state.milestones)) {
      return '';
    }
    // milestones need to be an object with keys as index and values as milestone object (for api request)
    const milestones = this.state.milestones
      .filter((milestone) => milestone.date && (milestone.target == 0 || milestone.target))
      .reduce((acc, milestone, index) => ({
        ...acc,
        [index]: {
          id: milestone.id && typeof milestone.id === 'number' ? milestone.id : null,
          date: milestone.date,
          label: milestone.label,
          target: milestone.target,
        }
      }), {});

    // if there are no milestones, return an empty string (for api request)
    return Object.keys(milestones).length > 0 ? milestones : '';
  }

  handleMilestonesChange(milestones) {
    this.setState({ milestones });
  }

  saveGroupResultsCompleted(callback = null, data = {}) {
    if (callback && typeof callback === 'function') {
      callback(data)
    } else {
      this.props.closeKrRightPane(true);
    }
  }

  saveGroupResults(isError = false, callback = null) {
    const { t } = this.props
    this.isSaveCustom(this.state.customInputData)
    let kr_duration=this.props.kr_duration;
    let isQuarter= this.props.isQuarter;
    this.setState({isCustomSave:[]})

    // Check for milestones validation errors
    if (this.krMilestonesSectionRef.current && !this.krMilestonesSectionRef.current.validateMilestones()) {
      toastr.error(t('Milestone dates and values must be within start and target range'));
      return false;
    }

    let errors = {}
    let { activeTab = '', metricObj } = this.state
    //let metricName = $("#metric-name-text").val();
    let metricName = this.props.krText
    if (
      typeof metricName === 'undefined' ||
      metricName == null ||
      metricName == ''
    ) {
      errors['metricName'] = true
			document.getElementById('metric-name-text').setAttribute('aria-invalid', 'true')
			setTimeout(() =>{
				document.getElementById('metric-name-text').focus()
			})
    }
    if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0 ){
      errors["customokr"] = t(`Please enter required field`);
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})
      setTimeout(() => {
        this.setState({customFiledRequired:true})
        document.querySelector('#cutomobj').scrollIntoView({
          behavior: 'smooth',
        })
      }, 200)

    }
    if (activeTab == '') {
      errors['select_tab'] = t('Choose a response type')
    } else {
      let metricSurveyLength = metricObj.metricSurvey.length
      if (!metricSurveyLength) {
        errors['select_people'] = t('Search and select a person')
      }
      if (metricSurveyLength) {
        if (activeTab == 'group-scale') {
          if (metricObj.lower_limit == '') {
            errors['lower_limit'] = t('Add lower limit')
          } else if (
            metricObj.lower_limit &&
            !isNumberWithComma(metricObj.lower_limit)
          ) {
            errors['lower_limit'] = t('Enter numeric value')
          }
          if (metricObj.upper_limit == '') {
            errors['upper_limit'] = t('Add upper limit')
          } else if (
            metricObj.upper_limit &&
            !isNumberWithComma(metricObj.upper_limit)
          ) {
            errors['upper_limit'] = t('Enter numeric value')
          }
          if (
            isNumberWithComma(metricObj.lower_limit) &&
            isNumberWithComma(metricObj.upper_limit) &&
            parseFloat(metricObj.upper_limit) <
              parseFloat(metricObj.lower_limit)
          ) {
            errors['less_lower_limit'] =
              t('Lower limit should be less than upper limit.')
          }
        } else {
          let targetMsg =
            activeTab == 'group-yesorno' ? 'Add target' : 'Add a target value'
          let stretchMsg =
          activeTab == 'group-yesorno' ? 'Add stretch' : 'Add a stretch value'
          if (this.state.isStretchEnabled) {
            if (metricObj.target == '' && metricObj.stretch == '') {
              errors['target'] = targetMsg
              errors['stretch'] = stretchMsg
            }
          } else {
            if (metricObj.target == '') {
              errors['target'] = targetMsg
            }
          }

          if (metricObj.target && !isNumberWithComma(metricObj.target)) {
            errors['target'] = t('Enter numeric value')
          }
          if (metricObj.stretch && !isNumberWithComma(metricObj.stretch)) {
            errors['stretch'] = 'Enter numeric value'
          }
          if ((metricObj.target !== "" && isNumberWithComma(metricObj.target)) && (metricObj.stretch !== "" && isNumberWithComma(metricObj.stretch))) {
            if (parseFloat(metricObj.stretch) < parseFloat(metricObj.target)) {
              errors["stretch"] = "Stretch target should be greater than committed"
            }
          }
          if (
            activeTab == 'group-numeric' &&
            (metricObj.progress_type == '' || metricObj.progress_type == 3)
          ) {
            errors['progress_type'] = t('Please select progress')
          }
        }
      }
    }
    //console.log('errors', errors);
    if (Object.keys(errors).length) {
      this.setState({ errors })

      if (errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 })
      } else if (
        (errors.lower_limit && errors.lower_limit.length > 0) ||
        (errors.target && errors.target.length > 0) ||
        (errors.stretch && errors.stretch.length > 0) ||
        (errors.upper_limit && errors.upper_limit.length > 0) ||
        (errors.less_lower_limit && errors.less_lower_limit.length > 0)
      ) {
        $('.krRightPaneContent').parent().animate({
          scrollTop: $('.krRightPaneContent')[0].scrollHeight - 150,
        })
      }
    } else {
      const dataTypeChanged = this.props.krType != this.props.lastType && this.props.addEditFlag
      const cadenceChanged =
        this.props.item.interval != metricObj.interval && this.props.addEditFlag
      const timePeriodChanged = isKrDurationChangedFromSaved(
        this.props.item,
        this.props.kr_duration,
        this.props.goalDetails
      )

      // Data type is delete-only and outranks the others, but saveItems() builds the
      // payload from state, so every detected change still has to be recorded here.
      if (resolveKrCaution({ dataTypeChanged }) === KR_CAUTION.DELETE_ONLY) {
        this.setState({
          confirmPopup: true,
          isAnuualQChange: timePeriodChanged,
          cadenceChanged,
        })
      } else {
        let { actions, item, goalDetails } = this.props
        //console.log('goalDetails', goalDetails);
        let goalId = goalDetails.id
        let permission = goalDetails.permission || ''
        if (typeof goalId !== 'undefined') {
          let krId = ''
          let _this = this
          let params = {}

          if (
            typeof item !== 'undefined' &&
            typeof item['id'] !== 'undefined'
          ) {
            params.id = item['id']
            krId = params.id
          }
          let krAlignSel = this.state.krAlingSelected
          let dependentKrsSel = this.state.krDependenciesSelected
          let krAligns = []
          let dependentKrs = []

          if (Object.keys(krAlignSel).length > 0) {
            krAlignSel.map((item) => {
              krAligns.push(item.id)
            })
          }

          if (Object.keys(dependentKrsSel).length > 0) {
            dependentKrsSel.map((item) => {
              dependentKrs.push(item.id)
            })
          }
          params.krAligns = krAligns
          params.dependentKr = dependentKrs
          params.name = this.props.krText
          params.kr_duration=kr_duration;
          params.isQuarter=isQuarter;
          let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
          let tagids=this.state.tags.length ? this.state.tags : ['']
          let finalTagsIds = [...nlpIds,...tagids]
          params.krTagIds = finalTagsIds;
          //params.owner = this.props.owner.id;
          params.real_owner = this.props.realOwner.id
          let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			    params.coOwners = coOwners.length > 0 ? Array.prototype.map
			     .call(coOwners, s => s.id)
			     .toString() : '';
          params.description = this.props.krNote
          params.source = 5
          params.type = 1
          if (goalDetails && goalDetails.all_metrics == 1) {
            params.permission_teams = goalDetails.permission_teams
            params.permission_biz = goalDetails.permission_biz
            params.permission = permission
          } else {
            params.permission_teams = this.state.teamPermissionSelected.map(
              (val) => val.id
            )
            params.permission_biz = this.state.bizPermissionSelected.map(
              (val) => val.id
            )
            params.permission = this.state.permissionstate.join(',')
          }

          params.metricSurvey = metricObj.metricSurvey.map((m) => m.user_id)
          params.interval = metricObj.interval
          params.weekly_update_day =
            metricObj.weekly_update_day == '' ? 5 : metricObj.weekly_update_day
          params.target = metricObj.target
          params.stretchTarget = metricObj.stretch
          params.progress_consider = metricObj.progress_consider ? 0 : 1
          if (activeTab == 'group-yesorno') {
            params.measure_metric_data = metricObj.measure_metric_data
            params.counting = 5
            params.metric = 0
          } else if (activeTab == 'group-scale') {
            params.lower_limit = metricObj.lower_limit
            params.upper_limit = metricObj.upper_limit
            params.counting = 6
            params.metric = 0
          } else {
            params.progress_type = metricObj.progress_type
            params.metric = metricObj.metric
            params.counting =
              metricObj.counting != 5 && metricObj.counting != 6
                ? metricObj.counting
                : 7
          }
          params.customField = JSON.stringify(this.props.customFieldsData);
          params['nested_krs'] = constructNestedKRPayload(this.props);
          // Include milestones data if available
          params.milestones = this.getMilestonesPayload();
          //console.log('params', params);
          //console.log('isError', isError);
          if (!isError) {
            const caution = resolveKrCaution({ timePeriodChanged, cadenceChanged })

            if (caution === KR_CAUTION.DELETE_ONLY) {
              this.setState({
                confirmPopup: true,
                isAnuualQChange: timePeriodChanged,
                cadenceChanged,
              })
            }
            else if (caution === KR_CAUTION.DELETE_OR_RETAIN) {
              this.setState({
                intervalConfirmPopup: true,
                isAnuualQChange: false,
                cadenceChanged,
              })
            }
            else {
              //console.log("same chcek");
              if (this.props.isChildKr && this.props.fromParentKr) {
                //params.ownerName = this.state.data_provider.name;
                params.duration = this.props.childKrDuration
                params.metricSurvey = metricObj.metricSurvey
                params.real_owner_fullname = this.props.showRealOwner
                  ? this.props.realOwner.name
                  : ''
                params.real_owner_pic = this.props.showRealOwner
                  ? this.props.realOwner.avatar
                  : ''
                if (this.props.item.parent) {
                  params.parent = this.props.item.parent
                }
                params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
                this.props.saveNestedKr(
                  params,
                  this.props.nestedKrIndex,
                  this.props.nestedKrAction
                )
              } else {
                if (this.props.item.parent) {
                  params.start_date = this.props.childKrDuration.start
                  params.end_date = this.props.childKrDuration.end
                  params.parent = this.props.item.parent
                }
                reactLoader(true)
                this.GoalServices.addEditKr({
                  goalId: goalId,
                  metric: params,
                }).then((response) => {
                  removeReactLoader()
                  if (response.data) {
                    if (!this.props.onlyMetEdit) {
                      let result = response.data.data
                      let krWeightage = null
                      if (result.krWeightage) {
                        krWeightage = result.krWeightage
                        delete result['krWeightage']
                      }
                      result = {
                        clusterItems: this.props.clusterData,
                        clusterCount: this.props.clusterData.length,
                        ...result,
                      }
                      if (result.parent) {
                        actions.addUpdateNestedKr(result)
                      } else {
                        if (krId) {
                          actions.editNewKr(krId, result)
                        } else {
                          actions.addNewKr(result)
                        }
                      }

                      if (krWeightage) {
                        _this.props.MetricChangeWeight(krWeightage)
                      }
                    }
                    this.saveGroupResultsCompleted(callback, response.data.data);
                    // this.GoalServices.triggerGoalMetricDetails({goalId});
                    // _this.props.closeKrRightPane(true)
                  }
                })
              }
            }
          }
        }
      }
    }
  }

  exitDeleteModal() {
    this.setState({ confirmPopup: false, intervalConfirmPopup: false,isAnuualQChange:false, })
  }
  saveItems() {
    let { actions, item, goalDetails } = this.props
    let isError = false
    let { activeTab = '', metricObj } = this.state
    //console.log('goalDetails', goalDetails);
    let kr_duration=this.props.kr_duration;
    let goalId = goalDetails.id
    let permission = goalDetails.permission || ''
    if (typeof goalId !== 'undefined') {
      let krId = ''
      let _this = this
      let params = {}
      if (typeof item !== 'undefined' && typeof item['id'] !== 'undefined') {
        params.id = item['id']
        krId = params.id
      }
      params.clearCache = this.state.cadenceChanged
      params.name = this.props.krText
      params.kr_duration=kr_duration;
      params.isQuarter=this.props.isQuarter;
      params.isPeriodChange=this.state.isAnuualQChange;
      params.description = this.props.krNote
      params.source = 5
      params.real_owner = this.props.realOwner.id;
      let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
      params.coOwners = coOwners.length > 0 ? Array.prototype.map
       .call(coOwners, s => s.id)
       .toString() : '';
      params.type = 1
      if (goalDetails && goalDetails.all_metrics == 1) {
        params.permission_teams = goalDetails.permission_teams
        params.permission_biz = goalDetails.permission_biz
        params.permission = permission
      } else {
        params.permission_teams = this.state.teamPermissionSelected.map(
          (val) => val.id
        )
        params.permission_biz = this.state.bizPermissionSelected.map(
          (val) => val.id
        )
        params.permission = this.state.permissionstate.join(',')
      }

      params.metricSurvey = metricObj.metricSurvey.map((m) => m.user_id)
      params.interval = metricObj.interval
      params.weekly_update_day =
        metricObj.weekly_update_day == '' ? 5 : metricObj.weekly_update_day
      params.target = metricObj.target
      params.stretchTarget = metricObj.stretch
      params.progress_consider = metricObj.progress_consider ? 0 : 1
      if (activeTab == 'group-yesorno') {
        params.measure_metric_data = metricObj.measure_metric_data
        params.counting = 5
        params.metric = 0
      } else if (activeTab == 'group-scale') {
        params.lower_limit = metricObj.lower_limit
        params.upper_limit = metricObj.upper_limit
        params.counting = 6
        params.metric = 0
      } else {
        params.progress_type = metricObj.progress_type
        params.metric = metricObj.metric
        params.counting =
          metricObj.counting != 5 && metricObj.counting != 6
            ? metricObj.counting
            : 7
      }
      let krAlignSel = this.state.krAlingSelected
      let dependentKrsSel = this.state.krDependenciesSelected
      let krAligns = []
      let dependentKrs = []

      if (Object.keys(krAlignSel).length > 0) {
        krAlignSel.map((item) => {
          krAligns.push(item.id)
        })
      }

      if (Object.keys(dependentKrsSel).length > 0) {
        dependentKrsSel.map((item) => {
          dependentKrs.push(item.id)
        })
      }
      params.krAligns = krAligns
      params.dependentKr = dependentKrs
      params['nested_krs'] = constructNestedKRPayload(this.props);
      params.customField = JSON.stringify(this.props.customFieldsData);
      //console.log('params', params);
      //console.log('isError', isError);
      if (!isError) {
        if (this.props.isChildKr && this.props.fromParentKr) {
          //params.ownerName = this.state.data_provider.name;
          params.duration = this.props.childKrDuration
          params.metricSurvey = metricObj.metricSurvey
          params.real_owner_fullname = this.props.showRealOwner
            ? this.props.realOwner.name
            : ''
          params.real_owner_pic = this.props.showRealOwner
            ? this.props.realOwner.avatar
            : ''
          if (this.props.item.parent) {
            params.parent = this.props.item.parent
          }
          params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
          this.props.saveNestedKr(
            params,
            this.props.nestedKrIndex,
            this.props.nestedKrAction
          )
        } else {
          if (this.props.item.parent) {
            params.start_date = this.props.childKrDuration.start
            params.end_date = this.props.childKrDuration.end
            params.parent = this.props.item.parent
          }
          reactLoader(true)
          this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
            (response) => {
              removeReactLoader()
              if (response.data) {
                if (!this.props.onlyMetEdit) {
                  let result = response.data.data
                  let krWeightage = null
                  if (result.krWeightage) {
                    krWeightage = result.krWeightage
                    delete result['krWeightage']
                  }
                  result = {
                    clusterItems: this.props.clusterData,
                    clusterCount: this.props.clusterData.length,
                    ...result,
                  }
                  if (result.parent) {
                    actions.addUpdateNestedKr(result)
                  } else {
                    if (krId) {
                      actions.editNewKr(krId, result)
                    } else {
                      actions.addNewKr(result)
                    }
                  }
                  if (krWeightage) {
                    _this.props.MetricChangeWeight(krWeightage)
                  }
                }
                // this.GoalServices.triggerGoalMetricDetails({goalId});
                _this.props.closeKrRightPane(true)
              }
            }
          )
        }
      }
    }
  }
  renderError(field) {
    return <ErrorTextComp errors={this.state.errors} field={field} />
  }

  changeInputValue(e) {
    var v = e.target.value.trim()
    let errors = this.state.errors
    let metricObj = this.state.metricObj
    let eventName = e.target.name
    if (typeof metricObj[eventName] !== 'undefined') {
      if (typeof errors[eventName] !== 'undefined') {
        delete errors[eventName]
      }
      let val =
        (v && isNumberWithComma(v)) || v == '' ? v : metricObj[eventName]
      this.setState({
        metricObj: Object.assign({}, this.state.metricObj, {
          [eventName]: val,
        }),
        errors,
      })
    }
  }

  changeCounting(e, item) {
    if (item) {
      this.setState({
        metricObj: Object.assign({}, this.state.metricObj, {
          counting: item.value,
        }),
      })
    }
  }

  changeMetricTypeOption(e, item) {
    if (item) {
      this.setState({
        metricObj: Object.assign({}, this.state.metricObj, {
          metric: item,
        }),
      })
    }
  }

  changeInterval(e, item) {
    if (item) {
      let selectInterval = 0
      if (this.state.activeTab != 'group-numeric' && e.target.value != 5) {
        selectInterval = 1
      }
      this.setState(
        {
          metricObj: Object.assign({}, this.state.metricObj, {
            interval: e.target.value,
            selectInterval: selectInterval,
          }),
        },
        () => {
          if (
            e.target.value === 5 &&
            (this.state.metricObj.measure_metric_data === 5 ||
              this.state.metricObj.measure_metric_data === 6)
          ) {
            this.changeYesOrNoOption(e, { value: 1 })
          }
        }
      )
    }
  }

  changeWeekDayUpdate(e, item) {
    if (item) {
      this.setState({
        metricObj: Object.assign({}, this.state.metricObj, {
          weekly_update_day: item,
        }),
      })
    }
  }

  changeYesOrNoOption(e, item) {
    if (item) {
      this.setState({
        metricObj: Object.assign({}, this.state.metricObj, {
          measure_metric_data: item,
        }),
      })
    }
  }

  changeProgressType(item) {
    var v = item.value
    let errors = this.state.errors
    if (typeof errors['progress_type'] !== 'undefined') {
      delete errors['progress_type']
    }
    this.setState({
      metricObj: Object.assign({}, this.state.metricObj, { progress_type: v }),
    })
  }

  changeExcludeObjective(e) {
    var chk = e.target.checked
    this.setState({
      metricObj: Object.assign({}, this.state.metricObj, {
        progress_consider: chk,
      }),
    })
  }

  removeItem(e, item) {
    let metricSurvey = this.state.metricObj.metricSurvey.filter(
      (u) => u.user_id != item.user_id
    )
    let newCheckVal = this.state.checkedValues.filter(
      (u) => u != `1_${item.user_id}`
    )
    this.setState({
      metricObj: Object.assign({}, this.state.metricObj, { metricSurvey }),
      checkedValues: newCheckVal,
    }, () => {
      const focusableRemoveElements = document.querySelectorAll(
        '[id^="deleteOptionBtn"]'
      )
      const focusableRemoveArr = Array.prototype.slice.call(focusableRemoveElements);
      const firstRemoveBtn = focusableRemoveArr[0];
      if (firstRemoveBtn) {
        firstRemoveBtn?.focus();
      } else {
        document.getElementById('search-input-box').focus()
      }
    })
  }

  constructTeamMemberUsers(users = []) {
    return users.map((u) => ({
      user_id: u.id,
      name: `${u.name} ${u.lastName}`,
      picture: u.pic,
      teamId: u.team_id,
    }))
  }

  checkPeopleValue(e, item, searchBoxInst) {
    if (item) {
      let _this = this
      let { metricObj, checkedValues, errors } = this.state
      let chk = e.target.checked
      let itemId =
        item.type + '_' + (item.type == '2' ? item.teamId : item.userId)
      if (chk) {
        checkedValues = [...checkedValues, itemId]
        if (item.type == '2') {
          if (typeof this.teamUserCollections[item.teamId] == 'undefined') {
            this.TeamServices.getTeamUserDetails({
              teamId: item.teamId,
              allUser: 1,
            }).then((response) => {
              if (response.data) {
                _this.teamUserCollections[item.teamId] =
                  _this.constructTeamMemberUsers(
                    response.data.inviteeList || []
                  )
                if (
                  typeof this.teamUserCollections[item.teamId] != 'undefined'
                ) {
                  let uniqueUsers = uniqueArrayObject(
                    [
                      ...metricObj.metricSurvey,
                      ..._this.teamUserCollections[item.teamId],
                    ],
                    'user_id'
                  )
                  metricObj.metricSurvey = uniqueUsers
                  _this.setState({ metricObj, checkedValues })
                }
              }
            })
          } else {
            if (typeof this.teamUserCollections[item.teamId] != 'undefined') {
              let uniqueUsers = uniqueArrayObject(
                [
                  ...metricObj.metricSurvey,
                  ..._this.teamUserCollections[item.teamId],
                ],
                'user_id'
              )
              metricObj.metricSurvey = uniqueUsers
              _this.setState({ metricObj, checkedValues })
            }
          }
        } else {
          let findUser = metricObj.metricSurvey.find(
            (u) => u.user_id == item.userId
          )
          if (!findUser) {
            let fullName =
              typeof item.fullName !== 'undefined'
                ? item.fullName
                : `${item.firstName} ${item.lastName}`
            metricObj.metricSurvey = [
              ...metricObj.metricSurvey,
              {
                user_id: item.userId,
                name: fullName,
                picture: item.userPic || item.picture,
              },
            ]
          }
        }
      } else {
        if (item.type == '1') {
          metricObj.metricSurvey = metricObj.metricSurvey.filter(
            (u) => u.user_id != item.userId
          )
        } else if (item.type == '2') {
          if (typeof this.teamUserCollections[item.teamId] != 'undefined') {
            metricObj.metricSurvey = metricObj.metricSurvey.filter(
              (u) => typeof u.teamId == 'undefined' || u.teamId != item.teamId
            )
          }
        }
        checkedValues = checkedValues.filter((v) => v != itemId)
      }
      if (typeof errors['select_people'] !== 'undefined') {
        delete errors['select_people']
      }
      this.setState({ metricObj, checkedValues, errors })
    }
  }

  renderPeopleTeamsSearchResults(values, searchboxInst) {
    if (values.length) {
      $('.krRightPaneContent').parent().animate({ scrollTop: 430 })
      let attr = {}
      attr.checkedValues = this.state.checkedValues
      attr.checkBoxProps = {
        onChange: this.checkPeopleValue,
      }
      return values.map((v) => (
        <PeopleSearchBoxList
          key={v.type + '_' + v.userId + '_' + v.teamId}
          row={v}
          inst={searchboxInst}
          attr={attr}
        />
      ))
    } else {
      return null
    }
  }

  getCounting() {
    let counting = 7
    let metricObj = this.state.metricObj
    if (metricObj.counting != 5 && metricObj.counting != 6) {
      if (metricObj.counting == '0') {
        switch (metricObj.metric) {
          case 1:
            counting = 7
            break
          case 2:
            counting = 8
            break
          case 3:
            counting = 9
            break
          default:
            break
        }
      } else {
        counting = metricObj.counting
      }
    }
    return counting
  }
  getIntervalText() {
    let interval = this.state.metricObj.interval
    let intervalText
    switch (Number(interval)) {
      case 1:
        intervalText = 'day'
        break
      case 2:
        intervalText = 'week'
        break
      case 3:
        intervalText = 'month'
        break
      case 4:
        intervalText = 'quarter'
        break
      case 6:
        intervalText = 'bi weekly'
        break
      default:
        intervalText = ''
    }
    // let intervalText =
    //   interval == 1
    //     ? 'day'
    //     : interval == 2
    //     ? 'week'
    //     : interval == 3
    //     ? 'month'
    //     : interval == 4
    //     ? 'quarter'
    //     : ''
    return intervalText != '' ? 'each ' + intervalText : ''
  }
  getEachUpdateOptions() {
    const { t } = this.props
    let interval = this.state.metricObj.interval
    let intervalText =
      interval == 1
        ? 'day'
        : interval == 2
        ? 'week'
        : interval == 3
        ? 'month'
        : 'quarter'
    return [
      {
        id: 'survey_total_all',
        label: t('Total of all responses over time'),
        value: 2,
      },
      {
        id: 'survey_total_each',
        label: t('Total of responses for each')+' '+ intervalText,
        value: 4,
      },
      {
        id: 'survey_avg_each',
        label: t('Average of responses for each')+' ' + intervalText,
        value: 1,
      },
    ]
  }

  getErrorClass(field) {
    return typeof this.state.errors[field] !== 'undefined'
      ? ' errorBorder  '
      : ''
  }
  isSaveCustom(isVal){
    let arr=[];
    let j=0;
    let keyArrCategory=[]
    let valArray = []
    isVal && Object.keys(isVal).forEach((v)=>{
      j++;
      isVal[v]["customFields"]&&
      Object.keys(isVal[v]["customFields"]).forEach(objv=>{
        keyArrCategory.push(objv)
        if(isVal[v]["customFields"][objv]['is_required']=='1'
        &&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
        ){
             arr.push(objv,v)
            }
        if(isVal[v]["customFields"][objv]["text"]){
          valArray.push(isVal[v]["customFields"][objv]["text"])
        }else{
          valArray.push('')
            }
      })
      if(j==Object.keys(isVal).length){
        this.setState({isRequirdCustomOkr:[...arr]})
      }
      let finalDataArray=[]
      for(let i=0;i<valArray.length;i++){
        if(Array.isArray(valArray[i])){
          valArray[i].forEach(val => {
            finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
          })
        }
        else{
          finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
        }

      }
      const tempData=finalDataArray
    })

  }

    isRequiredCustomOkrFiled(isVal,id){
      let cust_id=this.state.isCustomSave.find((u) => u == id);
      let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
      let fr= ar.filter(
          (u) => u != cust_id
        )
      this.setState({isCustomSave:fr})
      this.isSaveCustom(isVal)
      this.setState({customInputData:isVal})
  }
  saveAlignArr(alignData) {
    this.setState({
      krAlingSelected: alignData,
    })
  }
  saveDependentArr(dependentData) {
    this.setState({
      krDependenciesSelected: dependentData,
    })
  }
  saveTag = (childData) => {
    this.setState({ tags: childData })
  }
  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }
  render() {
    const { t, addOkrData = {} } = this.props
    let {metricObj} = this.state
    let activeTab = this.state.activeTab
    let numericCounting = this.getCounting()
    // console.log("activeTab", activeTab);
    let intervalOption = ''
    if (activeTab != 'group-numeric') {
      intervalOption = 'cascade'
    }
    let buttons = [
      {
        id: 'group-numeric',
        label: t('Numeric'),
        iconClass:
          'icon ' +
          (activeTab == 'group-numeric'
            ? 'icon-number-circle-24px-blue'
            : 'icon-number-circle-24px'),
        buttonWrapperClass: activeTab == 'group-numeric' ? 'active' : '',
        buttonClick: this.clickButtonEvent,
        ariaPressed : activeTab == 'group-numeric'
      },
      {
        id: 'group-yesorno',
        label: t('Yes or No'),
        iconClass:
          'icon ' +
          (activeTab == 'group-yesorno'
            ? 'icon-yes-no-24px-blue'
            : 'icon-yes-no-24px'),
        buttonWrapperClass: activeTab == 'group-yesorno' ? 'active' : '',
        buttonClick: this.clickButtonEvent,
        ariaPressed : activeTab == 'group-yesorno'
      },
      {
        id: 'group-scale',
        label: t('On a scale of')+ '...',
        iconClass:
          'icon ' +
          (activeTab == 'group-scale'
            ? 'icon-scale-24px-blue'
            : 'icon-scale-24px'),
        buttonWrapperClass: activeTab == 'group-scale' ? 'active' : '',
        buttonClick: this.clickButtonEvent,
        ariaPressed : activeTab == 'group-scale'
      },
    ]

    let rows = metricObj.metricSurvey || []
    let isError = Object.keys(this.state.errors).length
    let progressType = metricObj.progress_type
    let initialInterval = Number(metricObj.interval);
    let metricUnitVal = metricObj.metric > 0 ? metricObj.metric : 1;
    //console.log('render obj', metricObj);
    return (
      <div className="group-results-comp-wrapper" data-testid="group-results" >
        <div className="fieldcontent" >
          <div className="labeltext-25px"  data-testid="labeltext">
            {t('What type of survey will you conduct?')}{' '}
            <TypeFaceText key="typeface" />
            <HelpTextComp key="measurehelp" compStyle>
              <div>
                <ul>
                  <li>
                    <b>{t('Numeric')}:</b> {t(`Gather number, percentage, and currency data from teammates`)}
                  </li>
                  <li>
                    <b>{t('Yes or No')}:</b> {t(`“Yes” answers contribute positively to calculated progress`)}
                  </li>
                  <li>
                    <b>{t('On a Scale of')}:</b> {t(`Answers can be a range of prespecified numbers — upper limit is best possible`)}
                  </li>
                </ul>
              </div>
            </HelpTextComp>
          </div>
          <ButtonsComp key="group-result-buttons" buttons={buttons} />
          {isError ? this.renderError('select_tab') : ''}
        </div>
        {activeTab != '' ? (
          <div className="fieldcontent">
            <div className="labeltext-25px"  data-testid="labeltext">
              {t('Who do you want to participate?')}
              <TypeFaceText key="typeface" />
            </div>
            <div>
              <SearchBoxComp
                minLength="2"
                wrapperClass="group-results-people"
                url={'goal/getTeamAndOrgUsersList?team=true'}
                inputProps={{
                  placeholder: t('Search for people or teams'),
                  className: this.getErrorClass('select_people'),
                }}
                renderResultComp={this.renderPeopleTeamsSearchResults}
              />
            </div>
            {isError ? this.renderError('select_people') : ''}
          </div>
        ) : (
          ''
        )}
        {rows.length ? (
          <div>
            <div className="fieldcontent">
              <div className="labeltext-25px">{t('Selected participants')}:</div>
              <div className="container-scroll" style={{ width: '67%' }}>
                {rows.map((r) => (
                  <RollUpTableComp
                    type="people"
                    key={'people-' + r.user_id}
                    tableClass="rollup-survey-table"
                    row={r}
                    removeItem={this.removeItem}
                  />
                ))}
              </div>
            </div>
            <div className="fieldcontent">
              <div className='survey-participant-wrapper'>
                <div className="left" >
                   <StyledDropdown
                      id="survey-group-dropdown"
                      label={t("How often will you survey participants?")}
                      value={initialInterval}
                      initialValue={metricObj.interval}
                      onChange={this.changeInterval}
                      required
                      autoMenuWidth
                      optionTitleProp="name"
                      optionValueProp="value"
                      options={MetricFunc.getIntervalOptions(
                        intervalOption,
                        addOkrData.isEnabledBiweeklyKR,
                        true,
                        initialInterval === krdetailConstants.INTERVAL_BIQUARTERLY
                      )}
                      MenuProps={{
                        style: {
                        zIndex: '1500000'
                        },
                      }}
                    />
                  <div className="clear" />
                </div>
                {MetricFunc.isWeeklyInterval(metricObj.interval) ? (
                  <div className="left days-dropdown">
                    <div className="left ontext">{t('on')}</div>
                    <div className="left">
                      <StyledDropdown
                        data-testid="myAlign"
                        id="select-day-dropdown"
                        aria-label={t("select day to update")}
                        value={Number(metricObj.weekly_update_day)}
                        autoMenuWidth
                        onChange={(event) => {
                          this.changeWeekDayUpdate(event, event.target["value"]);
                        }}
                        optionTitleProp="name"
                        optionValueProp="value"
                        options={MetricFunc.getWeekDaysOptions()}
                        MenuProps={{
                          style: {
                          zIndex: '1500000'
                          },
                        }}
                      />
                      <div className="clear" />
                    </div>
                    <div className="clear" />
                  </div>
                ) : (
                  ''
                )}
                <div className="clear" />
              </div>
            </div>
            {activeTab == 'group-yesorno' ? (
              <div className="fieldcontent">
                <div className="labeltext-25px" id="cal-overall"  data-testid="labeltext">
                  {t('Calculate overall progress for this key result as')}:
                  <TypeFaceText key="typeface" />
                </div>
                <div className="dropdown-datacount-wrapper">
                  <StyledDropdown
                    data-testid="CalculateOverDropDown"
                    id="cal-overall-dropdown"
                    aria-labelledby="cal-overall"
                    value={Number(metricObj.measure_metric_data)}
                    autoMenuWidth
                    onChange={(event) => {
                      this.changeYesOrNoOption(event, event.target["value"] );
                    }}
                    optionTitleProp="name"
                    optionValueProp="value"
                    options={MetricFunc.getYesOrNoOptions(metricObj.interval)}
                    MenuProps={{
                      style: {
                        zIndex: '1500000'
                      },
                    }}
                  />
                  <div
                    className="inLineBlk"
                    style={{ fontSize: '14px', margin: '8px' }}
                  >
                    {this.getIntervalText()}
                  </div>
                  <div className="clear" />
                </div>
              </div>
            ) : (
              ''
            )}
            {activeTab == 'group-scale' ? (
              <div className="fieldcontent">
                  <div className="left" style={{ width: '144px' }}>
                    <div className="labeltext-25px" id="lower-limit-input">
                      {t('Lower limit of scale')}
                      <TypeFaceText key="typeface" />
                    </div>
                    <div>
                    <Textfield
                      aria-labelledby="lower-limit-input"
                      className={
                        'text-target-field text-target-width ' +
                        (isError ? this.getErrorClass('lower_limit') : '')
                      }
                      name="lower_limit"
                      autoComplete="off"
                      onChange={(e) => this.changeInputValue(e)}
                      type="text"
                      value={metricObj.lower_limit}
                    />
                    </div>
                    {isError ? this.renderError('lower_limit') : ''}
                  </div>
                  <div className="left" style={{ width: '144px' }}>
                    <div className="labeltext-25px" id="upper-limit-input">
                      {t('Upper limit of scale')}
                      <TypeFaceText key="typeface" />
                    </div>
                    <div>
                    <Textfield
                      aria-labelledby="upper-limit-input"
                      className={
                        'text-target-field text-target-width ' +
                        (isError ? this.getErrorClass('upper_limit') : '')
                      }
                      name="upper_limit"
                      autoComplete="off"
                      onChange={(e) => this.changeInputValue(e)}
                      type="text"
                      value={metricObj.upper_limit}
                    />
                    </div>
                    {isError ? this.renderError('upper_limit') : ''}
                  </div>
                  <div className="clear" />
                  {isError ? this.renderError('less_lower_limit') : ''}
              </div>
            ) : (
              <div className="fieldcontent">
                <div>
                  <div className="left marginR5">
                    <div
                      className={!this.state.isStretchEnabled ? "labeltext-25px" : "target-text-25px"}
                      id="target-value-input"
                      data-testid="labeltext"
                    >
                      {/* {activeTab == "group-yesorno"
													? "Your target count"
													: "Your total target"}{" "}
												*/}
                      {t('Target value')} <TypeFaceText key="typeface" />
                    </div>
                    {this.state.isStretchEnabled && ( <div className="marginL0">
                      Committed target
                      <HelpTextComp popUpClass="rightAlign" wrapperClass="committedKRHelpText marginL3">
                        When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target. This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.
                      </HelpTextComp>
                    </div> )}
                    <div>
                    <Textfield
                      aria-labelledby="target-value-input"
                      className={
                        'text-target-field ' +
                        (isError ? this.getErrorClass('target') : '') +
                        (this.state.isStretchEnabled ? ' stretch-text-target-width' : ' text-target-width')
                      }
                      name="target"
                      autoComplete="off"
                      placeholder="Enter Value"
                      onChange={(e) => this.changeInputValue(e)}
                      type="text"
                      value={metricObj.target}
                    />
                    </div>
                    {isError ? this.renderError('target') : ''}
                  </div>
                  { this.state.isStretchEnabled && (<div className="left" style={{ width: "120px" }}>
                    <div
                      className="labeltext-25px"
                      id="stretch-value-input"
                      data-testid="labeltext"
                    >
                    </div>
                    <div className="marginL0">
                      Stretch target
                      <HelpTextComp popUpClass="rightAlign" wrapperClass="committedKRHelpText marginL3">
                        Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed
                      </HelpTextComp>
                    </div>
                    <div>
                    <Textfield
                      aria-labelledby="stretch-value-input"
                      className={
                        'text-target-field stretch-text-target-width ' +
                        (isError ? this.getErrorClass('stretch') : '')
                      }
                      name="stretch"
                      autoComplete="off"
                      placeholder="Enter Value"
                      onChange={(e) => this.changeInputValue(e)}
                      type="text"
                      value={metricObj.stretch}
                    />
                    </div>
                    {isError ? this.renderError('stretch') : ''}
                  </div> )}
                  {activeTab == 'group-numeric' ? (
                    <div className="left" style={{ marginLeft: 25 }}>
                      <div className="labeltext-25px" />
                      { this.state.isStretchEnabled ? <div className="labeltext-22px" /> : ""}
                      <div>
                        <StyledDropdown
                          data-testid="myAlign"
                          id="unit-measure-dropdown"
                          aria-label="Unit of measurement"
                          value={Number(metricUnitVal)}
                          autoMenuWidth
                          onChange={(event) => {
                            this.changeMetricTypeOption(event, event.target["value"]);
                          }}
                          optionTitleProp="name"
                          optionValueProp="value"
                          options={this.getMetricTypeTextOptions()}
                          MenuProps={{
                            style: {
                              zIndex: '1500000'
                            },
                          }}
                        />
                        <div className="clear" />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="clear" />
                </div>
                {activeTab == 'group-numeric' ? (
                  <div className="fieldcontent">
                    <div className="labeltext-25px" style={{height: 25}}>
                      <label id="survey-radio-groupid"> {t('Calculate overall progress for the key result as')}:{' '}</label>
                      <HelpTextComp key="measurehelp" compStyle>
                        <div>
                          <ul>
                            <li>
                              <b>{t('Total of all responses over time')}:</b> {t(`If selected participants answer “2” and “4” for one update and then “2” and “3” for another update, the progress will show “11”.`)}
                            </li>
                            <li>
                              <b>{t('Total of responses for each update')}:</b> {t(`If selected participants answer “2” and “4” for an update, the progress will show “6”.`)}
                            </li>
                            <li>
                              <b>{t('Average of responses for each update')}:</b> {t(`If selected participants answer “2” and “4” for an update, the progress will show “3”.`)}
                            </li>
                          </ul>
                        </div>
                      </HelpTextComp>
                    </div>
                    <div className="survey-numeric-progress-type-wrapper" aria-labelledby="survey-radio-groupid" role="radiogroup" id='survey-radio-btn-group-aE-create-ws'>
                        <RadioGroupButtons
                          name="survery_progress_type"
                          defaultValue={progressType}
                          items={this.getEachUpdateOptions()}
                          onChange={this.changeProgressType}
                        />
                      {isError ? this.renderError('progress_type') : ''}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
  {this.props.customData && Object.keys(this.props.customData).length > 0 && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
         {  (this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields ) &&
                <Customokr
                  customData={this.props.customData}
                  isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                  onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                  customFiledRequired={true}
                  renderError={this.renderError}
                  isCustomSave={this.state.isCustomSave}
                />
        }
            {!this.props.isChildKr && <div className="breakline" />}

            {this.props.addOkrData.display_nested_kr &&
              !this.props.isChildKr &&
              Math.ceil(
                moment(this.props.goalDetails.target_date).diff(
                  moment(this.props.goalDetails.start_date),
                  'days',
                  true
                )
              ) >= 360 && (
                <NestedInlineComp
                  {...this.props}
                  actions={this.props.actions}
                  nested_krs={this.props.nested_krs}
                  updateNestedKrs={this.props.updateNestedKrs}
                />
              )
            }
            {!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveGroupResults}/>}
            {!this.props.isChildKr && (
              <KrAlignDependance
                {...this.props}
                saveDependentArr={this.saveDependentArr}
                saveAlignArr={this.saveAlignArr}
                krAlingArr={this.props.item.kr_aligns}
                krDependenciesArr={this.props.item.kr_dependent}
              />
            )}
            {!this.props.mitChildKr && !this.props.isChildKr && (
              <KrMilestonesSection ref={this.krMilestonesSectionRef} {...this.props} metricState={this.state} metric={this.props.item} onChange={this.handleMilestonesChange} />
            )}
            <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
            <AddKrTag
              metric={this.props.item}
              goalId={this.props.goalDetails.id}
              taghandler={this.saveTag}
              nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}

            />
            {!this.props.isChildKr && (
              <div className="fieldcontent">
                <StyledCheckbox
                  id="exclude_objective"
                  label={
                    t('Exclude from objective progress calculation')
                  }
                  isChecked={metricObj.progress_consider}
                  onChange={this.changeExcludeObjective}
                />
              </div>
            )}

            <div className="fieldcontent">
              {!(
                this.props.goalDetails &&
                this.props.goalDetails.all_metrics == 1
              ) && (
                <div className="pT10">
                  <div className="viewPermissionArea">
                    <span>
                      {t('View permissions in addition to')}{' '}
                      {this.props.goalDetails.type == 1 ? t(' team ') : t(' owner ')}
                      <div
                        className="metricTargetHelptext permissionHelpText"
                        onMouseEnter={(event) => {
                          this.setState({ permissionHelpPopUp: true })
                        }}
                        onMouseLeave={(event) => {
                          this.setState({ permissionHelpPopUp: false })
                        }}
                      />
                      {this.state.permissionHelpPopUp && (
                        <div className="basic-popup">
                         {t(` You can give your whole organization permission to
                          view your Key Result, or just your team and
                          managers`)}
                        </div>
                      )}
                    </span>
                  </div>
                  <div className="pB10">
                    <PermissionComp
                      {...this.props}
                      teamPermissionData={this.teamPermissionData}
                      bizPermissionData={this.bizPermissionData}
                      permissionData={this.permissionData}
                      hide={this.state.hide}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        {this.state.confirmPopup && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t(this.state.isAnuualQChange ? 'Save Key Result with new duration' : 'Save Key Result with New Data Type')}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t(this.state.isAnuualQChange
              ? 'Are you sure you want to change the duration on this Key Result? This will eliminate all Updates and Confidence Flags on the Key Result.'
              : 'Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.')}
            buttonText={t(this.state.isAnuualQChange ? 'Change duration' : 'Save')}
          />
        )}

         {this.props.addOkrData.groupKRCustomFields != 4 && <div className="krBreak" aria-hidden="true" />}
        {this.state.intervalConfirmPopup && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t("Changing update frequency & deleting prior update")}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={
              t('Are you sure you want to change the update frequency of this key result?')
            }
            deleteContentSecondExtra={
              t('This change will delete updates previously made to the key result data.')
            }
            deleteContentSecondNote={
              `${t('Note')}: ${t('Before making this change, you may review previous key result updates from the key result activity section.')}`
            }
            buttonText="Save"
            controlStyle={{
              deleteModalContent: { minHeight: '248px' },
            }}
          />
        )}
      </div>
    )
  }
}

export default GroupResultsComp
